import styled from "@emotion/styled";

export const TokenImageContainer = styled("div")`
    display: flex;
    margin-right: 2px;
`;
